import { Paper, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { styled } from "@mui/material/styles";

import PeopleIcon from '@mui/icons-material/People';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import { useNavigate } from "react-router-dom";
import { checkRouteAccess } from "../../utils/common";
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import Iconify from "../iconify";

const CustomMenuSection = styled('div')(() => ({
    flexDirection: "column",
    position: "fixed",
    left: 65,
    minWidth: "72px",
    zIndex: 100,
    color: "#637381"
}))

const MenuPaper = styled(Paper)(({ }) => ({
    width: 180,
    minHeight: 235,
    textAlign: 'center',
    ml: '12px',
    mt: '-10px',
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
}));

const SmsBarHoverMenu = ({ custombox }) => {
    const navigate = useNavigate()

    return (
        <CustomMenuSection sx={{
            display: custombox ? "flex" : "none",
        }}>
            <MenuPaper elevation={20}>
                <List sx={{
                    marginTop: "5px",
                    padding: "0px",
                }}>
                   {checkRouteAccess("/sms") && <ListItem disablePadding sx={{
                        margin: "0px"
                    }}>
                        <ListItemButton onClick={() => navigate("/sms")}>
                            <ListItemIcon sx={{
                                // minWidth: "34px",
                                color: "grey.600",
                            }}>
                                <Iconify icon="mingcute:announcement-line" />
                            </ListItemIcon>
                            <ListItemText primary="Gateway" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}

                    {checkRouteAccess("/smsTemplateList") && <ListItem disablePadding sx={{
                        margin: "0px"
                                        }}>
                        <ListItemButton onClick={() => navigate("/smsTemplateList")}>
                            <ListItemIcon sx={{
                                // minWidth: "34px",
                                color: "grey.600",
                            }}>
                                <Iconify icon="tabler:binary-tree-2" />
                            </ListItemIcon>
                            <ListItemText primary="Template List" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}

                    {checkRouteAccess("/senderIdList") && <ListItem disablePadding >
                        <ListItemButton component="a" onClick={() => navigate("/senderIdList")}>
                            <ListItemIcon sx={{
                                // minWidth: "auto",
                                color: "grey.600",
                            }}>
                                <Iconify icon="mdi:tts" />
                            </ListItemIcon>
                            <ListItemText primary="Sender ID" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}
                    {checkRouteAccess("/smsPlans") && <ListItem disablePadding >
                        <ListItemButton component="a" onClick={() => navigate("/smsPlans")}>
                            <ListItemIcon sx={{
                                // minWidth: "auto",
                                color: "grey.600",
                            }}>
                                <Iconify icon="mdi:tag-outline" />
                            </ListItemIcon>
                            <ListItemText primary="SMS Plan" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}
                    {checkRouteAccess("/smsRealNumber") && <ListItem disablePadding >
                        <ListItemButton component="a" onClick={() => navigate("/smsRealNumber")}>
                            <ListItemIcon sx={{
                                // minWidth: "auto",
                                color: "grey.600",
                            }}>
                                <Iconify icon="ant-design:number-outlined" />
                            </ListItemIcon>
                            <ListItemText primary="Real Number" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}
                     {checkRouteAccess("/retrySettings") && <ListItem disablePadding >
                        <ListItemButton component="a" onClick={() => navigate("/retrySettings")}>
                            <ListItemIcon sx={{
                                // minWidth: "auto",
                                color: "grey.600",
                            }}>
                                <Iconify icon="iconmind:mcp-retry-policy-outline-bold" />
                            </ListItemIcon>
                            <ListItemText primary="Retry settings" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}
                    {checkRouteAccess("/smsAdminSetting") && <ListItem disablePadding >
                        <ListItemButton component="a" onClick={() => navigate("/smsAdminSetting")}>
                            <ListItemIcon sx={{
                                color: "grey.600",
                            }}>
                                <Iconify icon="icon-park-solid:setting" />
                            </ListItemIcon>
                            <ListItemText primary="Admin Setting" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}
                    {checkRouteAccess("/smsAdminSettingList") && <ListItem disablePadding >
                        <ListItemButton component="a" onClick={() => navigate("/smsAdminSettingList")}>
                            <ListItemIcon sx={{
                                color: "grey.600",
                            }}>
                                <Iconify icon="solar:list-bold" />
                            </ListItemIcon>
                            <ListItemText primary="Admin Setting List" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}
                     {checkRouteAccess("/implicitValidityPeriod") && <ListItem disablePadding >
                        <ListItemButton component="a" onClick={() => navigate("/implicitValidityPeriod")}>
                            <ListItemIcon sx={{
                                color: "grey.600",
                            }}>
                                <Iconify icon="iconmind:implicit-flow-duotone-bold" />
                            </ListItemIcon>
                            <ListItemText primary="Implicit Validity" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}
                </List>
            </MenuPaper>
        </CustomMenuSection>

    )
}
export default SmsBarHoverMenu;